import { useQuery } from '@apollo/client';
import { Space } from 'antd';
import { ORDER_BY_DICTIONARY, PAGE_SIZE, TABLE_PROPS } from 'appConstants';
import ListCard from 'components/ListCard';
import SortSelect from 'components/SortSelect';
import Table from 'components/Table';
import { GET_USERS } from 'operations/queries/queryUser';
import queryString from 'query-string';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { processQueryFilerParams } from 'utils/filter';
import { columns } from '../columns';
import ExportUser from './ExportUser';

const UserList = () => {
  const { search } = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => queryString.parse(search), [search]);
  const page = useMemo(() => searchParams.page || 1, [searchParams.page]);
  const sort = useMemo(
    () => searchParams.sort || 'EARLIEST',
    [searchParams.sort]
  );
  const filterQuery = useMemo(
    () => processQueryFilerParams(searchParams),
    [searchParams]
  );

  const {
    loading: isUsersLoading,
    error: usersError,
    data: usersConnect
  } = useQuery(GET_USERS, {
    variables: {
      take: PAGE_SIZE,
      skip: PAGE_SIZE * page - PAGE_SIZE,
      order: [ORDER_BY_DICTIONARY[sort].value],
      where: { ...filterQuery, userType: filterQuery?.userType || { neq: 0 } }
    }
  });

  const onPaginate = page => {
    history.push({
      pathname: '/danh-sach-bien-tap-vien',
      search: queryString.stringify({ ...searchParams, page })
    });
  };

  const setOrderBy = sort => {
    history.push({
      pathname: '/danh-sach-bien-tap-vien',
      search: queryString.stringify({ ...searchParams, page: 1, sort })
    });
  };

  if (usersError) return <div>Oops, đã có vấn đề xảy ra 😅😅😅</div>;
  const users = usersConnect?.users?.items?.map(item => ({
    ...item,
    key: item.id
  }));
  const total = usersConnect?.users?.totalCount;

  return (
    <ListCard
      left={`Có ${total} kết quả`}
      right={
        <Space>
          <ExportUser filterQuery={filterQuery} />
          <SortSelect value={sort} onChange={setOrderBy} />
        </Space>
      }
    >
      <Table
        {...TABLE_PROPS}
        columns={columns}
        dataSource={users}
        pagination={{
          total,
          pageSize: PAGE_SIZE,
          onChange: onPaginate,
          current: page * 1,
          quantity: users?.length
        }}
        loading={isUsersLoading}
      />
    </ListCard>
  );
};

export default UserList;
